import { BiPlusCircle } from "react-icons/bi";
import Button from "../../button/Button";
import TranslatableText from "../../translations/TranslatableText";

interface AddNoteButtonProps {
    onAdd: () => void;
}

export const AddNoteButton = ({ onAdd }: AddNoteButtonProps) => (
    <Button
        className="standard-action-button"
        onClick={onAdd}
    >
        <BiPlusCircle size={20} />
        <TranslatableText
            className="fs-12 ps-1 ff-normal-cond"
            translationKey="module.add_note"
        />
    </Button>
); 